import React from 'react';
import PropTypes from 'prop-types';

import FooterBottom from './FooterBottom';
import { companyInfoPropsType } from '../../helpers/fetchCmsContent';
import Link from '../../helpers/Link';
import { PAGE_CONTACT } from '../../../config/pages';
import Directus from '../../helpers/directusLink';

const getVatId = (companyInfo, language) => {
    const vatIdItem = companyInfo && companyInfo.company_registration_number.find(({ key }) => key === 'vat_id');
    return Directus.getTranslationByLang(vatIdItem.translations, language);
};

const Footer = ({
    t, openPage, language, claim, companyInfo
}) => {
    const vatId = companyInfo && getVatId(companyInfo, language);
    const country = t('footer.headquarter.address.country');
    return (
        <div className="container-footer">
            <div className="layout">
                <div className="page-footer" id="page-footer">
                    <div className="footer-content clearfix" id="footer-content">
                        <div className="footer-logo" id="footer-logo">
                            <div className="logo-image" id="logo-image01">
                                <img src={ require('../../../assets/images/logo-white.svg') } alt="Lemlock logo"/>
                            </div>
                            <div className="logo-text" id="logo-text-01" >
                                <div dangerouslySetInnerHTML={ { __html: claim } }/>
                            </div>
                        </div>
                        <div className="footer-contact" id="footer-contact-01">
                            <div className="footer-contact-title" id="footer-contact-title-01">{ t('footer.contact.title') }</div>
                            <div className="footer-contact-list" id="footer-contact-list-01">
                                {
                                    t('footer.contact.people').map((person, index) => (
                                        <div className="footer-contact-elem" id="footer-contact-elem-01" key={ index }>
                                            <div className="footer-contact-avatar" id="footer-contact-avatar-01">
                                                {
                                                    process.env.DEFAULT_LANGUAGES === 'de' ? (
                                                        <img
                                                          src={ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-64-de.jpg`) }
                                                          srcSet={
                                                            `${ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-64-de.jpg`) } 1x,
                                                            ${ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-128-de.jpg`) } 2x`
                                                        }
                                                          alt={ `${ person.name } - ${ person.occupation }` }
                                                        />
                                                    ) : (
                                                        <img
                                                          src={ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-64.jpg`) }
                                                          srcSet={
                                                            `${ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-64.jpg`) } 1x,
                                                            ${ require(`../../../assets/images/footer/contact-${ (index + 1) }-avatar-128.jpg`) } 2x`
                                                        }
                                                          alt={ `${ person.name } - ${ person.occupation }` }
                                                        />
                                                    )
                                                }
                                            </div>
                                            <div className="footer-contact-details" id="footer-contact-details-01">
                                                <div className="footer-contact-name" id="footer-contact-name-01">{ person.name }</div>
                                                <div className="footer-contact-occupation" id="footer-contact-occupation-01">{ person.occupation }</div>
                                                {
                                                companyInfo &&
                                                    <div className="footer-contact-text" id="footer-contact-text-01">
                                                        <span>{ t('footer.contact.labels.mobile') }: </span>
                                                        <a href={ `tel:${ companyInfo.phone }` }>
                                                            { companyInfo.phone }
                                                        </a>
                                                        <br/>
                                                        <span>{ t('footer.contact.labels.mail') }: </span>
                                                        <Link
                                                          openPage={ openPage }
                                                          language={ language }
                                                          page={ PAGE_CONTACT }

                                                        >
                                                            { person.email }
                                                        </Link>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="footer-contact" id="footer-contact-02">
                            <div className="footer-contact-title" id="footer-contact-title-02">{ t('footer.headquarter.title') }</div>
                            <div className="footer-contact-list" id="footer-contact-list-02">
                                <div className="footer-contact-elem" id="footer-contact-elem-02">
                                    <div className="footer-contact-avatar" id="footer-contact-avatar-02">
                                        {
                                            process.env.DEFAULT_LANGUAGES === 'de' ? (
                                                <img
                                                  src={ require('../../../assets/images/footer/headquarter-avatar-64-de.jpg') }
                                                  srcSet={
                                                    `${ require('../../../assets/images/footer/headquarter-avatar-64-de.jpg') } 1x,
                                                    ${ require('../../../assets/images/footer/headquarter-avatar-128-de.jpg') } 2x` }
                                                  alt={ t('footer.headquarter.address.company') }
                                                />
                                            ) : (
                                                <img
                                                  src={ require('../../../assets/images/footer/headquarter-avatar-64.jpg') }
                                                  srcSet={
                                                    `${ require('../../../assets/images/footer/headquarter-avatar-64.jpg') } 1x,
                                                    ${ require('../../../assets/images/footer/headquarter-avatar-128.jpg') } 2x` }
                                                  alt={ t('footer.headquarter.address.company') }
                                                />
                                            )
                                        }
                                    </div>
                                    <div className="footer-contact-details" id="footer-contact-details-02">
                                        <div className="footer-contact-name" id="footer-contact-name-02">{ t('footer.headquarter.address.company') }</div>
                                        { companyInfo &&
                                            (
                                            <div className="footer-contact-text" id="footer-contact-text-02">
                                                { companyInfo.street }<br/>
                                                { `${ companyInfo.zip_code } ${ companyInfo.town }${ country && `, ${ country }` }` }<br/>
                                                { vatId ? `${ vatId.name }: ${ vatId.number }` : ''}
                                            </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FooterBottom t={ t } openPage={ openPage } language={ language }/>
                </div>
            </div>
        </div>
    );
};

Footer.defaultProps = {
    companyInfo: null
};
Footer.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/content/common/Footer.jsx